<template>
  <v-select
    class="search-select-item"
    :menu-props="{contentClass:'search-menu-content', maxHeight: 'calc(100vh - 24px)' }"
    :label="$t('ARTWORK.TECHNIQUE')"
    :items="[]"
    :loading="loading"
    ref="techniqueSelect"
    solo
    flat
    multiple
    hide-details
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ $t('ARTWORK.TECHNIQUE') }}</span>
    </template>

    <template v-slot:append>
      <v-icon
        v-if="filters.techniquesSelected.length"
        @click="onTechniqueClear"
        size="18"
        style="margin-right: 12px;"
      >fas fa-times</v-icon>
      <v-icon class="mr-1">fas fa-angle-down</v-icon>
    </template>

    <template v-slot:no-data>
      <v-treeview
        :value="filters.techniquesSelected"
        @input="change"
        :items="techniques"
        selected-color="primary"
        class="ml-3"
        item-value="key"
        open-on-click
        selectable
        transition
        return-object
        hoverable
      ></v-treeview>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["filters", "techniques", "loading"],
  data() {
    return {
      treeInputEventCount: 0
    };
  },

  methods: {
    onTechniqueClear(e) {
      e.stopPropagation();
      this.filters.techniquesSelected = [];
      this.$refs.techniqueSelect.blur();
    },
    change(items) {
      this.treeInputEventCount += 1;
      if (this.treeInputEventCount <= 1) return;
      this.filters.techniquesSelected = items;
      this.$emit("change");
    }
  }
};
</script>
